"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotGrantedBeaconError = void 0;
const __1 = require("..");
class NotGrantedBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.NOT_GRANTED_ERROR, 'You do not have the necessary permissions to perform this action. Please initiate another permission request and give the necessary permissions.');
        this.name = 'NotGrantedBeaconError';
        this.title = 'Permission Not Granted';
    }
}
exports.NotGrantedBeaconError = NotGrantedBeaconError;
//# sourceMappingURL=NotGrantedBeaconError.js.map